var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wpart",staticStyle:{"height":"300px"}},[_c('div',{staticClass:"wpart-templale3"},[_c('UserProfileWebpart')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }